import * as types from "./ActionTypes";
import Api from "../api/BannersApi";

export const getBanners = () => {
    return (dispatch) => {
        return Api.getBanners()
            .then((banners) => {
                dispatch({ type: types.GET_BANNERS_SUCCEEDED, banners: banners });
            })
            .catch((error) => {
                dispatch({ type: types.GET_BANNERS_FAILED, error });
            });
    };
};
